import { Reveal } from "./Reveal";
import { HEADSHOT } from "../../lib/assets";

export const About = () => {
  return (
    <section id="about" className="py-20 lg:py-32 bg-white" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <Reveal className="relative">
            <div className="rounded-[24px] overflow-hidden border border-slate-200 shadow-xl shadow-slate-900/5">
              <img
                src={HEADSHOT}
                alt="Noman Zaheer"
                className="w-full h-[420px] sm:h-[520px] object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -right-3 sm:right-6 rounded-2xl bg-teal-600 text-white px-6 py-4 shadow-lg">
              <div className="font-display text-lg font-bold leading-tight">Noman Zaheer</div>
              <div className="text-sm text-teal-50">School Trustee Candidate</div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <Reveal>
            <p className="text-xs font-semibold tracking-[0.2em] uppercase text-teal-600">Meet Noman</p>
            <h2 className="font-display font-extrabold tracking-tight text-slate-900 text-3xl md:text-4xl lg:text-5xl mt-3 leading-tight">
              A local parent bringing a fresh perspective to our schools
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-7 space-y-5 text-base md:text-lg leading-relaxed text-slate-600 max-w-2xl">
              <p>
                Noman Zaheer is a parent, technology professional, and long-time resident
                of Pembina Trails.
              </p>
              <p>
                Through his work in information technology and post-secondary education,
                Noman understands the importance of preparing students for a rapidly
                changing future. He believes strong schools are built through
                collaboration, innovation, accountability, and meaningful engagement with
                families.
              </p>
              <p className="text-slate-900 font-medium">
                Noman is running for School Trustee because he believes every student
                deserves the opportunity to learn, thrive, and succeed.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
